function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import _ from 'lodash';
import Iframe from './Iframe';
var AllpagoCreditCardFrame = /*#__PURE__*/function (_React$Component) {
  function AllpagoCreditCardFrame() {
    var _this;
    _classCallCheck(this, AllpagoCreditCardFrame);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AllpagoCreditCardFrame, [].concat(args));
    _defineProperty(_this, "setIframeReference", function (f) {
      _this.iframe = f;
    });
    return _this;
  }
  _inherits(AllpagoCreditCardFrame, _React$Component);
  return _createClass(AllpagoCreditCardFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      window.addEventListener('message', function (e) {
        return _this2.handleEvents(e);
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var numberOfInstallments = this.props.numberOfInstallments;
      return numberOfInstallments !== nextProps.numberOfInstallments || this.formDataChanged(nextProps);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var formData = this.props.formData;
      if (this.formDataChanged(prevProps)) {
        this.iframe.contentWindow.postMessage(formData, '*');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      window.removeEventListener('message', function (e) {
        return _this3.handleEvents(e);
      });
    }
  }, {
    key: "handleEvents",
    value: function handleEvents(e) {
      var _this$props = this.props,
        setCheckoutId = _this$props.setCheckoutId,
        requestSave = _this$props.requestSave;
      if (e.origin !== window.origin && e.origin !== window.location.origin) {
        return;
      }
      if (e.data.checkoutId) {
        setCheckoutId(e.data.checkoutId);
      }
      if (e.data.height) {
        document.querySelector('.allpagoFrame').style.height = "".concat(e.data.height, "px");
        document.querySelector('.allpagoFrame').style.minHeight = '247px';
      }
      if (e.data.saving) {
        requestSave();
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      this.iframe.contentWindow.postMessage({
        checkout: true
      }, '*');
    }
  }, {
    key: "formDataChanged",
    value: function formDataChanged(nextProps) {
      var formData = this.props.formData;
      return !_.isEqual(nextProps.formData, formData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        receiptCode = _this$props2.receiptCode,
        total = _this$props2.total,
        numberOfInstallments = _this$props2.numberOfInstallments;
      return /*#__PURE__*/React.createElement("div", {
        className: "allpagoFrame col-12"
      }, /*#__PURE__*/React.createElement(Iframe, {
        receiptCode: receiptCode,
        total: total,
        setReference: this.setIframeReference,
        onLoad: function onLoad() {
          return _this4.onLoad();
        },
        numberOfInstallments: numberOfInstallments
      }));
    }
  }]);
}(React.Component);
export default AllpagoCreditCardFrame;